module.exports = __webpack_public_path__ + "img/icon-lock-white.a723908e.svg";